// extracted by mini-css-extract-plugin
export var columnList = "_iu-0";